var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54071 19.5041L12 24L14.4593 19.5041C15.6231 17.3742 17.3742 15.6231 19.5041 14.4593L24 12L19.5041 9.54073C17.3742 8.37696 15.6231 6.62581 14.4593 4.4959L12 1.71661e-05L9.54071 4.4959C8.37694 6.62581 6.6258 8.37696 4.49588 9.54073L0 12L4.49588 14.4593C6.6258 15.6231 8.37694 17.3742 9.54071 19.5041Z",
    fill: "#00C8B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSparkle);
export default __webpack_public_path__ + "static/media/GreenSparkle.ac48d1a1b8b00714d3eb0f9ced7c1f3e.svg";
export { ForwardRef as ReactComponent };